import { render, staticRenderFns } from "./FileInfo.vue?vue&type=template&id=f809d894&scoped=true"
import script from "./FileInfo.vue?vue&type=script&lang=js"
export * from "./FileInfo.vue?vue&type=script&lang=js"
import style0 from "./FileInfo.vue?vue&type=style&index=0&id=f809d894&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f809d894",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f809d894')) {
      api.createRecord('f809d894', component.options)
    } else {
      api.reload('f809d894', component.options)
    }
    module.hot.accept("./FileInfo.vue?vue&type=template&id=f809d894&scoped=true", function () {
      api.rerender('f809d894', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DeviceAccounts/FileInfo/FileInfo.vue"
export default component.exports